/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Unlink_Cancel_CtaInputs */

const he_account_delivery_unlink_cancel_cta = /** @type {(inputs: Account_Delivery_Unlink_Cancel_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השאר מחובר`)
};

const en_account_delivery_unlink_cancel_cta = /** @type {(inputs: Account_Delivery_Unlink_Cancel_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep linked`)
};

/**
* | output |
* | --- |
* | "Keep linked" |
*
* @param {Account_Delivery_Unlink_Cancel_CtaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_unlink_cancel_cta = /** @type {((inputs?: Account_Delivery_Unlink_Cancel_CtaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Unlink_Cancel_CtaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_unlink_cancel_cta(inputs)
	return en_account_delivery_unlink_cancel_cta(inputs)
});